<template>
  <div class="home">
    <CountryChart />
    <div class="container disclaimer">
      <div class="row">
        <p class="disclaimer">
          The designations employed and the presentation of material on this map do not imply the expression of any opinion whatsoever on the part of the Secretariat of the United Nations concerning the legal status of any country, territory, city or area or of its authorities or concerning the delimitation of its frontiers or boundaries.
          The depiction and use of boundaries, geographic names and related data shown on maps and included in lists, tables, documents, and databases on this web site are not warranted to be error free nor do they necessarily imply official endorsement or acceptance by the United Nations.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CountryChart from "@/elements/charts/CountryChart.vue";

export default {
  name: "home",
  components: {
    CountryChart
  }
};
</script>


<style scoped>
.disclaimer {
  /* width: 50%; */
  /* margin: auto; */
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/elements/CountryChartView.vue